//@flow

export const NOTE_ENTITY_TYPE = 'CRM_CONVERSATION';
export const NOTE_MAX_CHARACTERS = 500;
